import { useCallback, useEffect } from 'react'
import Debug from 'debug'
import { observer } from 'mobx-react-lite'
import { useQueryClient } from '@tanstack/react-query'

import { useGetCustomer } from '@jotta/grpc-connect-client/customer'
import { PhotoState } from '@jotta/grpc-connect-openapi/customer'
import { LoadingOverlay } from '@jotta/ui/LoadingOverlay'

import { joinTimeline } from '../../api/photosApi'

const debug = Debug('jotta:photo:timelineActivation')

export const TimelineActivation = observer(function TimelineActivation({
  children,
}: {
  children: React.ReactNode
}) {
  const queryClient = useQueryClient()
  const isPhotosActivated = Boolean(
    useGetCustomer().data?.photoState !== PhotoState.NOT_ACTIVE,
  )
  const join = useCallback(async () => {
    await joinTimeline()
    await queryClient.invalidateQueries({
      predicate: ({ queryKey }) =>
        Boolean(
          Array.isArray(queryKey) &&
          queryKey.length &&
          queryKey[0] === 'customer',
        ),
    })
  }, [queryClient])

  useEffect(() => {
    if (!isPhotosActivated) {
      join()
    }
  }, [isPhotosActivated, join])

  if (isPhotosActivated) {
    return children
  }
  return <LoadingOverlay id="TimelineActivation" open position="absolute" />
})
